import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AppleProfilePresetEffects } from './apple-profile-preset.effects';
import { APPLE_PROFILE_PRESET_FEATURE_KEY, appleProfilePresetReducer } from './apple-profile-preset.reducer';

export const provideAppleProfilePresetStore = () => [
  provideState(APPLE_PROFILE_PRESET_FEATURE_KEY, appleProfilePresetReducer),
  provideEffects([AppleProfilePresetEffects]),
];
